import { Text, View } from '@react-pdf/renderer';
import { groupBy } from '../../../../utils/mapping-helpers/groupBy';
export function generateModulesOrClassesRow(brandOptions, modules, brandCountry, locale, styles, degreeCredits) {
  const degreeCreditRows = degreeCredits ? degreeCredits.replaceAll('<p>', '').replaceAll('</p>', '.').replaceAll('<br>','').split('.'):null;
  const titleRow = (
    <View style={[styles.tableRow, styles.rowHeading, styles.courseDetailsHeader]}>
      <View style={styles.courseDetailHeadText}>
        <Text>{brandOptions.modulesName ?? 'Modules'}</Text>
      </View>
    </View>
  );
  const degreeCreditsText = degreeCredits
    ? degreeCreditRows.map((credit, index) => {
        return (
          <View key={index} style={[styles.tableRow]}>
            <Text style={styles.paragraphWithLeft}>{credit}</Text>
          </View>
        );
      })
    : null;
  const degreeCreditsRow = degreeCredits ? (
    <View>
      <View style={[styles.tableRow, styles.tableRowMargin10, styles.creditHeader]}>
        <Text style={styles.paragraphHeading}>Degree Program Components</Text>
      </View>
      {degreeCreditsText}
    </View>
  ) : null;
  const separator = <View style={[styles.tableRow, styles.divider]}></View>;
  let modulesHeader = null;
  let modulesRow = null;
  if (brandCountry === 'US') {
    const groupedBySemester = brandCountry === 'US' && groupBy(modules, 'semesterTermTaught');
    modulesHeader = (
      <View style={[styles.tableRow, styles.tableRowMargin10]}>
        <Text style={[styles.creditNumber]}>
          <Text style={styles.paragraphHeading}>Credit Number</Text>
        </Text>
        <Text style={[styles.classTitle]}>
          <Text style={styles.paragraphHeading}>
            {brandOptions?.modulesName ? brandOptions.modulesName : 'Core'} Title
          </Text>
        </Text>
        <Text style={[styles.creditNumber]}>
          <Text style={styles.paragraphHeading}>
            {brandOptions?.customizeCredits || 'Credit Value'}
          </Text>
        </Text>
      </View>
    );
    modulesRow = Object.keys(groupedBySemester).map((key) => {
      const semesterHead = key !== 'undefined' && (
        <View style={[styles.tableRow, styles.tableRowMargin10]}>
          <Text>
            <Text style={[styles.paragraphHeading, styles.subTitleGray]}>{brandOptions?.termName} {key}</Text>
          </Text>
        </View>
      );

      const usModulesRow = groupedBySemester[key].map((module, index) => {
        return (
          <View key={`dateV-${index}`} style={[styles.tableRow, styles.tableRowMargin10]}>
            <Text key={`sdate-${index}`} style={[styles.creditNumber]}>
              <Text style={styles.paragraph}>{module.code}</Text>
            </Text>
            <Text key={`edate-${index}`} style={[styles.classTitle]}>
              <Text
                style={[styles.paragraph, module.deliveredBy === 'INTO' ? styles.into : undefined]}
              >
                {module.name}
              </Text>
            </Text>
            <Text key={`edate-${index}`} style={[styles.creditNumber]}>
              <Text style={styles.paragraphHeading}>
                {module.credits} {brandOptions?.customizeCredits || 'Credits'}
              </Text>
            </Text>
          </View>
        );
      });

      const usModulesTotalrow = (
        <View style={[styles.tableRow, styles.tableRowMargin10]}>
          <Text style={[styles.creditNumber]}>
            <Text style={styles.paragraphHeading}> </Text>
          </Text>
          <Text style={[styles.classTitle]}>
            <Text style={styles.paragraph}>
              Total{' '}
              {brandOptions?.customizeCredits
                ? brandOptions.customizeCredits.toLowerCase()
                : 'credits'}
            </Text>
          </Text>
          <Text style={[styles.creditNumber]}>
            <Text style={styles.paragraphHeading}>
              {groupedBySemester[key]
                .map((el) => (el.credits ? +el.credits : 0))
                .reduce((acc, curr) => acc + curr, 0)}
              {` ${brandOptions?.customizeCredits || 'Credits'}`}
            </Text>
          </Text>
        </View>
      );
      return (
        <View key={key}>
          {semesterHead}
          {usModulesRow}
          {separator}
          {usModulesTotalrow}
        </View>
      );
    });
  } else {
    modulesHeader = (
      <View style={[styles.tableRow, styles.tableRowMargin10]}>
        <Text style={[styles.feesCoulumn]}>
          <Text style={styles.paragraphHeading}>
            Core {brandOptions?.modulesName ? brandOptions.modulesName.toLowerCase() : `modules`}
          </Text>
        </Text>
        <Text style={[styles.feesSecondCoulumn]}>
          <Text style={styles.paragraphHeading}>
            {brandOptions?.customizeCredits || 'Credit value'}
          </Text>
        </Text>
      </View>
    );

    const coreModulesRow = modules?.some((el) => el.type === 'Core')
      ? modules
          ?.filter((el) => el.type === 'Core')
          ?.map((module, index) => {
            return (
              <View key={`dateV-${index}`} style={[styles.tableRow, styles.tableRowMargin10]}>
                <Text key={`sdate-${index}`} style={[styles.feesCoulumn]}>
                  <Text style={styles.paragraph}>{module.name}</Text>
                </Text>
                <Text key={`edate-${index}`} style={[styles.feesSecondCoulumn]}>
                  <Text style={styles.paragraphHeading}>
                    {+module.credits
                      ? `${+module.credits} ${brandOptions?.customizeCredits || 'Credits'}`
                      : module.credits}
                  </Text>
                </Text>
              </View>
            );
          })
      : null;

    const specialistModulesRow = modules?.some((el) => el.type === 'Specialist')
      ? modules
          ?.filter((el) => el.type === 'Specialist')
          ?.map((module, index) => {
            const specialistModuleHeader =
              index === 0 ? (
                <View key={`dateV-${index}`} style={[styles.tableRow, styles.tableRowMargin10]}>
                  <Text key={`sdate-${index}`} style={[styles.tableRow]}>
                    <Text style={[styles.paragraphHeading, styles.subTitleGray]}>
                      Specialist{' '}
                      {brandOptions?.modulesName
                        ? brandOptions.modulesName.toLowerCase()
                        : `modules`}
                    </Text>
                  </Text>
                </View>
              ) : null;
            return (
              <>
                {specialistModuleHeader}
                <View key={`dateV-${index}`} style={[styles.tableRow, styles.tableRowMargin10]}>
                  <Text key={`sdate-${index}`} style={[styles.feesCoulumn]}>
                    <Text style={styles.paragraph}>{module.name}</Text>
                  </Text>
                  <Text key={`edate-${index}`} style={[styles.feesSecondCoulumn]}>
                    <Text style={styles.paragraphHeading}>
                      {+module.credits
                        ? `${+module.credits} ${brandOptions?.customizeCredits || 'Credits'}`
                        : module.credits}
                    </Text>
                  </Text>
                </View>
              </>
            );
          })
      : null;
    modulesRow = (
      <View>
        {coreModulesRow}
        {separator}
        {specialistModulesRow}
      </View>
    );
  }
  return (
    <View>
      {titleRow}
      {degreeCreditsRow}
      <View style={styles.courseDetail}>
        {modulesHeader}
        {modulesRow}
      </View>
    </View>
  );
}
